import { useQuery } from '@tanstack/react-query';
import { KimMHOReportService } from '@/infra/services/kim-mho-report';
import { QUERY_KEYS } from '@/utils/query-keys';

interface GetKimMHOParams {
	organization_id: string;
	company_id: string;
	id: string;
}

const Service = KimMHOReportService.getInstance();

export const useGetKimMho = (params: GetKimMHOParams) => {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_KIM_MHO_REPORT, params],
		queryFn: () => Service.getReport(params),
		enabled: !!params.organization_id && !!params.company_id && !!params.id,
		retry: 0
	});
};
